import React, { Component } from 'react';

class EditInterior extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Diseño Interior</div>
        );
    }
}
 
export default EditInterior;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditInterior.jsx